import logoImage from "../assets/images/BCBSKS_logo.png";
import {CLIENT_NAME, CLIENT_THEME} from "../utils/constants";
import { getFormFields } from '../components/bcbsks/fields';
import FormFooter from "../components/bcbsks/FormFooter";
import APP_ENV from "../config/appEnv";

const config = {
    clientName: CLIENT_NAME.BCBSKS,
    isMultiLingual: true,
    hideLanguageSwitcher: true,
    isPlainButton: true,

    // theme
    theme: CLIENT_THEME.BCBSKS,

    // header
    logo: logoImage,
    logoWidth: 304,
    logoHeight: 'auto',
    logoLink: APP_ENV.CLIENT_RETURN_URL,

    // entry form
    entryForm: {
        title: 'ADVISORY GROUP - APPLICATION',
        customFields: {
            enabled: true,
            fieldGetter: getFormFields,
        },
        showReturn: true,
        showCancel: false,
    },

    // footer
    footer: {
        customFooter: {
            enabled: true,
            component: FormFooter,
        },
        meta: {
            materialId: 'H7063_AG_OnlineApp_C',
            materialSubtext: '37-094 07/25',
        },
        isLicenseInfo: true
    },

    tracking: {
        mail: "/?utm_source=mail&utm_medium=online&utm_campaign=recruit",
        mo: "/?utm_source=mail&utm_medium=online&utm_campaign=recruit",
        mp: "/?utm_source=mail&utm_medium=paper&utm_campaign=recruit",
        email: "/?utm_source=email&utm_medium=online&utm_campaign=recruit",
        cs: "/?utm_source=cs&utm_medium=phone&utm_campaign=recruit",
        enews: "/?utm_source=enews&utm_medium=online&utm_campaign=recruit",
        sms: "/?utm_source=sms&utm_medium=phone&utm_campaign=recruit",
    }
    
}

export default config;
